import "../css/TempSchoolPage.css";
import { useState } from "react";
import SchoolDetails from "./SchoolDetails";

// S.S. Agrawal School
import ssagI1 from "../schoolPhotos/agrawal/1.jpg";
import ssadV1 from "../videosSchools/agrawal/1.mp4";
import ssadV2 from "../videosSchools/agrawal/19.mp4";
import ssadV3 from "../videosSchools/agrawal/2.mp4";
import ssadV4 from "../videosSchools/agrawal/3.mp4";

//Modern Primary School
import mpsI1 from "../schoolPhotos/modernPrimary/2.jpg";
import mpsI2 from "../schoolPhotos/modernPrimary/3.jpg";
import mpsI3 from "../schoolPhotos/modernPrimary/4.jpg";
import mpsI4 from "../schoolPhotos/modernPrimary/q.jpg";
import mpsV1 from "../videosSchools/modernPrimary/2.mp4";
import mpsV2 from "../videosSchools/modernPrimary/3.mp4";
import mpsV3 from "../videosSchools/modernPrimary/4.mp4";
import mpsV4 from "../videosSchools/modernPrimary/5.mp4";

//Pandit Rao Agashe School
import prasI1 from "../schoolPhotos/agashe/1.jpg";
import prasI2 from "../schoolPhotos/agashe/2.jpg";
import prasI3 from "../schoolPhotos/agashe/3.jpg";
import prasI4 from "../schoolPhotos/agashe/4.jpg";
import prasI5 from "../schoolPhotos/agashe/5.jpg";
import prasV1 from "../videosSchools/agashe/1.mp4";
import prasV2 from "../videosSchools/agashe/2.mp4";

//Modern Secondary School
import mssI1 from "../schoolPhotos/modernSecondary/img1.jpeg";
import mssI2 from "../schoolPhotos/modernSecondary/img2.jpeg";
import mssI3 from "../schoolPhotos/modernSecondary/img3.jpeg";
import mssV1 from "../videosSchools/modernSecondary/1.mp4";
import mssV2 from "../videosSchools/modernSecondary/2.mp4";
import mssV3 from "../videosSchools/modernSecondary/3.mp4";
import mssV4 from "../videosSchools/modernSecondary/4.mp4";
import mssV5 from "../videosSchools/modernSecondary/5.mp4";

//Seth Dagdu
import sdI1 from "../schoolPhotos/sethDagdu/img1.jpeg";
import sdI2 from "../schoolPhotos/sethDagdu/img2.jpeg";
import sdV1 from "../videosSchools/sethDagdu/video1.mp4";
import sdV2 from "../videosSchools/sethDagdu/video2.mp4";
import sdV3 from "../videosSchools/sethDagdu/video2.mp4";

//RIS SCHOOL
import risI1 from "../schoolPhotos/RIS_School/1.jpeg";
import risI2 from "../schoolPhotos/RIS_School/2.jpeg";
import risI3 from "../schoolPhotos/RIS_School/3.jpeg";
import risI4 from "../schoolPhotos/RIS_School/4.jpeg";
import risI5 from "../schoolPhotos/RIS_School/5.jpeg";
import risV1 from "../videosSchools/RisSchool/v1.mp4";

// CATS Preschool
import cpsI1 from "../schoolPhotos/CATSPreschool/img1.jpeg";
import cpsI2 from "../schoolPhotos/CATSPreschool/img2.jpeg";
import cpsI3 from "../schoolPhotos/CATSPreschool/img3.jpeg";
import cpsI4 from "../schoolPhotos/CATSPreschool/img4.jpeg";
import cpsI5 from "../schoolPhotos/CATSPreschool/img5.jpeg";
import cpsI6 from "../schoolPhotos/CATSPreschool/img6.jpeg";
import cpsI7 from "../schoolPhotos/CATSPreschool/img7.jpeg";
import cpsI8 from "../schoolPhotos/CATSPreschool/catsimg1.jpeg";
import cpsV1 from "../videosSchools/CATSPreschool/video1.mp4";
import cpsV2 from "../videosSchools/CATSPreschool/video2.mp4";
import cpsV3 from "../videosSchools/CATSPreschool/catsvdo1.mp4";
import cpsV4 from "../videosSchools/CATSPreschool/catsvdo2.mp4";

//giggles Pre-school
import swgI1 from "../schoolPhotos/giggles_images/gig-img1.jpeg";
import swgI2 from "../schoolPhotos/giggles_images/gig-img2.jpeg";
import swgI3 from "../schoolPhotos/giggles_images/gig-img3.jpeg";
import swgV1 from "../videosSchools/giggles/gig-mainvideo1.mp4";
import swgV2 from "../videosSchools/giggles/gig-vdo5.mp4";

// Arjuna Cambridge school
import acsI1 from "../schoolPhotos/Arjuna/arjun-img1.jpeg";
import acsI2 from "../schoolPhotos/Arjuna/arjun-img2.jpeg";
import acsI3 from "../schoolPhotos/Arjuna/arjun-img3.jpeg";
import acsI4 from "../schoolPhotos/Arjuna/arjun-img4.jpeg";
import acsV1 from "../videosSchools/Arjuna/arjun-vdo1.mp4";

// Leo Kids
import lkI1 from "../schoolPhotos/Leo Kids/leo-img1.jpeg";
import lkV1 from "../videosSchools/Leo Kids/leo-vdo1.mp4";
import lkV2 from "../videosSchools/Leo Kids/Leo Kids Workshop.mp4";

// Crayoans Preschool
import cppsI1 from "../schoolPhotos/Craayons preschool/cps-img1.jpeg";
import cppsI2 from "../schoolPhotos/Craayons preschool/cps-img2.jpeg";
import cppsI3 from "../schoolPhotos/Craayons preschool/cps-img3.jpeg";
import cppsI4 from "../schoolPhotos/Craayons preschool/cps-img4.jpeg";
import cppsV1 from "../videosSchools/Craayons preschool/cps-vdo1.mp4";
import cppsV2 from "../videosSchools/Craayons preschool/cps-vdo2.mp4";

// Little Wonder Preschool
import lwnpI1 from "../schoolPhotos/Little Wonder preschool/lwns-img1.jpeg";
import lwnpI2 from "../schoolPhotos/Little Wonder preschool/lwns-img2.jpeg";
import lwnpI3 from "../schoolPhotos/Little Wonder preschool/lwns-img3.jpeg";
import lwnpI4 from "../schoolPhotos/Little Wonder preschool/lwns-img4.jpeg";
import lwnpI5 from "../schoolPhotos/Little Wonder preschool/lwns-img5.jpeg";
import lwnpI6 from "../schoolPhotos/Little Wonder preschool/lwns-img4.jpeg";
import lwnpI7 from "../schoolPhotos/Little Wonder preschool/lwns-img4.jpeg";
import lwnpI8 from "../schoolPhotos/Little Wonder preschool/lwns-img4.jpeg";
import lwnpV1 from "../videosSchools/Little Wonder preschool/lwns-vdo1.mp4";

//Intelliots Preschool
import itpI1 from "../schoolPhotos/IntelliotsPreschool/ITP-img1.jpeg";
import itpI2 from "../schoolPhotos/IntelliotsPreschool/ITP-img2.jpeg";
import itpI3 from "../schoolPhotos/IntelliotsPreschool/ITP-img1.jpeg";
import itpI4 from "../schoolPhotos/IntelliotsPreschool/ITP-img4.jpeg";
import itpI5 from "../schoolPhotos/IntelliotsPreschool/itp-img5.jpeg";
import itpI6 from "../schoolPhotos/IntelliotsPreschool/itp-img6.jpeg";
import itpI7 from "../schoolPhotos/IntelliotsPreschool/itp-img7.jpeg";
import itpI8 from "../schoolPhotos/IntelliotsPreschool/itp-img8.jpeg";
import itpV1 from "../videosSchools/IntelliotsPreschool/ITP-vdo1.mp4";
import itpV2 from "../videosSchools/IntelliotsPreschool/ITP-vdo2.mp4";
import itpV3 from "../videosSchools/IntelliotsPreschool/ITP-vdo3.mp4";
import itpV4 from "../videosSchools/IntelliotsPreschool/ITP-vdo4.mp4";
import itpV5 from "../videosSchools/IntelliotsPreschool/itp-vdo5.MP4";

// EuroKids Preschool
import ekpI1 from "../schoolPhotos/EuroKIdsPreschool/EKP-img1.jpeg";
import ekpI2 from "../schoolPhotos/EuroKIdsPreschool/EKP-img2.jpeg";
import ekpI3 from "../schoolPhotos/EuroKIdsPreschool/EKP-img3.jpeg";
import ekpI4 from "../schoolPhotos/EuroKIdsPreschool/EKP-img4.jpeg";
import ekpI5 from "../schoolPhotos/EuroKIdsPreschool/EKP-img5.jpeg";
import ekpI6 from "../schoolPhotos/EuroKIdsPreschool/EKP-img6.jpeg";
import ekpI7 from "../schoolPhotos/EuroKIdsPreschool/EKP-img7.jpeg";
import ekpI8 from "../schoolPhotos/EuroKIdsPreschool/EKP-img8.jpeg";
import ekpV1 from "../videosSchools/EuroKidsPreschool/EKP-vdo2.mp4";
import ekpV2 from "../videosSchools/EuroKidsPreschool/EKP-vdo3.mp4";
import ekpV3 from "../videosSchools/EuroKidsPreschool/EKP-vdo4.mp4";
import ekpV4 from "../videosSchools/EuroKidsPreschool/EKP-vdo5.mp4";

// Jumping  Jhapak
import jjI1 from "../schoolPhotos/JumpingJhapak/jjI1.jpeg";
import jjI2 from "../schoolPhotos/JumpingJhapak/jji2.jpeg";
import jjV1 from "../schoolPhotos/JumpingJhapak/WhatsApp Video 2026-05-28 at 14.03.18.mp4";
import jjV2 from "../schoolPhotos/JumpingJhapak/WhatsApp Video 2026-05-28 at 14.03.19.mp4";

//CNS Preeschool
import cnsv2 from  "../videosSchools/CNSPreschool/CNSv2.mp4";
import cnsv3 from  "../videosSchools/CNSPreschool/CNSv3.mp4";
import cnsv4 from  "../videosSchools/CNSPreschool/CNSv4.mp4";
import CNS from "../schoolPhotos/CNS/CNS.png";
import CNS1 from "../schoolPhotos/CNS/CNS1.png";
import CNS2 from "../schoolPhotos/CNS/CNS2.png";
import CNS3 from "../schoolPhotos/CNS/CNS3.png";
import CNS4 from "../schoolPhotos/CNS/CNS4.png";
import CNS5 from "../schoolPhotos/CNS/CNS5.png";
import CNS6 from "../schoolPhotos/CNS/CNS6.png";
import CNS7 from "../schoolPhotos/CNS/CNS7.png";
import CNS8 from "../schoolPhotos/CNS/CNS8.png";
import CNS9 from "../schoolPhotos/CNS/CNS9.png";
import CNS10 from "../schoolPhotos/CNS/CNS10.png";
import CNS11 from "../schoolPhotos/CNS/CNS11.png";
import CNS12 from "../schoolPhotos/CNS/CNS12.png";
import CNSP1 from "../schoolPhotos/CNS Preschool/WhatsApp Image 2026-07-30 at 13.01.20 (1).jpeg";
import CNSP2 from "../schoolPhotos/CNS Preschool/WhatsApp Image 2026-07-30 at 13.01.20.jpeg";
import CNSP3 from "../schoolPhotos/CNS Preschool/WhatsApp Image 2026-08-20 at 13.27.03 (1).jpeg";
import CNSP4 from "../schoolPhotos/CNS Preschool/WhatsApp Image 2026-08-20 at 13.27.03.jpeg";
import CNSV5 from "../schoolPhotos/CNS Preschool/WhatsApp Video 2026-08-20 at 17.45.58.mp4";

//Maharashtra mandal
import MMP from  "../schoolPhotos/Maharashtriya Mandal/1.png";
import MMP2 from  "../schoolPhotos/Maharashtriya Mandal/2.png";
import MMP3 from  "../schoolPhotos/Maharashtriya Mandal/3.png";
import MMP4 from  "../schoolPhotos/Maharashtriya Mandal/4.png";
import MMP5 from  "../schoolPhotos/Maharashtriya Mandal/5.png";
import MMV from  "../videosSchools/MaharashtriyaMandal/Video1.mp4";
import MMV2 from "../schoolPhotos/MVM English Medium/WhatsApp Video 2026-08-25 at 15.17.29.mp4";

//P.U.Jain
import PUJ from  "../schoolPhotos/P.U.Jain/1.png";
import PUJ2 from  "../schoolPhotos/P.U.Jain/2.png";
import PUJ3 from  "../schoolPhotos/P.U.Jain/3.png";
import PUJ4 from "../schoolPhotos/P.U.Jain copy/WhatsApp Image 2026-07-24 at 15.04.40.jpeg";
import PUJ5 from "../schoolPhotos/P.U.Jain copy/WhatsApp Image 2026-08-07 at 12.32.21.jpeg";
import PUJ6 from "../schoolPhotos/P.U.Jain copy/WhatsApp Image 2026-08-07 at 13.01.56.jpeg";
import PUJ7 from "../schoolPhotos/P.U.Jain copy/WhatsApp Image 2026-08-14 at 15.07.31 (1).jpeg";
import PUJ8 from "../schoolPhotos/P.U.Jain copy/WhatsApp Image 2026-08-24 at 12.44.21 (1).jpeg";

//Sanskar dream
import SDV from  "../videosSchools/SanskarDream/sanskarD.mp4";
import SDI1 from "../schoolPhotos/Sanskar Dream/WhatsApp Image 2026-07-23 at 16.37.13.jpeg";
import SDI2 from "../schoolPhotos/Sanskar Dream/WhatsApp Image 2026-07-23 at 16.37.16 (2).jpeg";
import SDI3 from "../schoolPhotos/Sanskar Dream/WhatsApp Image 2026-07-23 at 16.37.17 (1).jpeg";
import SDI4 from "../schoolPhotos/Sanskar Dream/WhatsApp Image 2026-07-23 at 16.37.18 (1).jpeg";
import SDI5 from "../schoolPhotos/Sanskar Dream/WhatsApp Image 2026-07-23 at 16.37.18.jpeg";

//Abhishek Vidyalaym
import AVV from  "../videosSchools/AbhishekVidyalayam/AVV.mp4";
import AVI1 from "../schoolPhotos/Abhishek Vidyalayam/WhatsApp Image 2026-07-18 at 23.19.08.jpeg";
import AVI2 from "../schoolPhotos/Abhishek Vidyalayam/WhatsApp Image 2026-08-01 at 11.34.34.jpeg";
import AVI3 from "../schoolPhotos/Abhishek Vidyalayam/WhatsApp Image 2026-08-22 at 21.07.44 (1).jpeg";
import AVV2 from "../schoolPhotos/Abhishek Vidyalayam/Abhishek Vidyalayam Day-2.mp4";
import AVV3 from "../schoolPhotos/Abhishek Vidyalayam/Abhishek Vidyalayam Day-3.mp4";

//D B Nimbalkar
import DBN from  "../videosSchools/DBNimbalkar/DBN.mp4";

// Divine English Medium School
import divineI1 from "../schoolPhotos/Divine School/divineScoolimg1.png";
import divineI2 from "../schoolPhotos/Divine School/divineScoolimg2.png";
import divineV1 from "../videosSchools/Divine School/Divine English Medium School.mp4";
import divineV2 from "../videosSchools/Divine School/WhatsApp Video 2026-09-17 at 1.08.26 PM.mp4";

//Panditrao pre-primary
import PRAO1 from  "../schoolPhotos/PanditRao/PRAO1.png";
import PRAO2 from  "../schoolPhotos/PanditRao/PRAO2.png";
import PRAO3 from  "../schoolPhotos/PanditRao/PRAO3.png";
import PRAO4 from  "../schoolPhotos/PanditRao/PRAO4.png";
import PRAO5 from  "../schoolPhotos/PanditRao/PRAO5.png";
import PRAO6 from  "../schoolPhotos/PanditRao/PRAO6.png";
import PRAO7 from  "../schoolPhotos/PanditRao/PRAO7.png";
import PRAO8 from  "../schoolPhotos/PanditRao/PRAO8.png";
import PRV1 from  "../videosSchools/PanditRao/PRV1.mp4";

//Phonics World
import PW1 from  "../schoolPhotos/Phonics/PW1.png";
import PW2 from  "../schoolPhotos/Phonics/PW2.png";
import PWV1 from  "../videosSchools/Phonics/PWV1.mp4";
import PWV2 from  "../videosSchools/Phonics/PWV2.mp4";
import PWV3 from  "../videosSchools/Phonics/PWV3.mp4";

//Logos
import CNSLogo from "../SchoolLogos/CNS.png";
import PUJainLogo from "../SchoolLogos/p.u.png";
import PhonicsLogo from "../SchoolLogos/phonics_world.png";
import SanskarLogo from "../SchoolLogos/Sanskar.png";
import SaidreamzLogo from "../SchoolLogos/Sai-dreamz.png";
import panditraoLogo from "../SchoolLogos/panditrao.jpeg";
import dadamaharajLogo from "../SchoolLogos/dadamaharaj.png";
import AryaMandirLogo from "../SchoolLogos/Aryamandir.png";
import modernSecondaryLogo from "../SchoolLogos/ModernSec.png";
import ArjunaLogo from "../SchoolLogos/Arjuna.png";
import SethDagduLogo from "../SchoolLogos/sethdagdu.png";
import SSAgrawalLogo from "../SchoolLogos/S.S.Agarwal.png";
import modernPrimaryLogo from "../SchoolLogos/ModernPri.png";
import LearningCurveLogo from "../SchoolLogos/LearningCurve.png";
import JumpingJhapakLogo from "../SchoolLogos/JumpingJhapak.png";
import EuroPreschoolLogo from "../SchoolLogos/EuroPreschool.png";
import IntelliotsPreschoolLogo from "../SchoolLogos/IntelliotsPreschool.png";
import CraayonsPreschoolLogo from "../SchoolLogos/CraayonsPreschool.png";
import LeoKidsPreschoolLogo from "../SchoolLogos/LeoKidsPreschool.png";
import ShineWithGigglesLogo from "../SchoolLogos/ShineWithGiggles.png";
import CATSPreschoolLogo from "../SchoolLogos/C.A.T.S.Preschool.png";
import LittleWondersPreschoolLogo from "../SchoolLogos/LittleWonder'sPreschool.png";
import maharashtramandalSchoolLogo from "../SchoolLogos/maharashtriyamandal.png";
import AbhishekVidyalayamLogo from "../SchoolLogos/AbhishekVidyalayam.png";
import DBNibarkarLogo from "../SchoolLogos/DBNibarkar.png";
import RahulInternationalSchoolLogo from "../SchoolLogos/RahulInternationalSchool.png";
import DivineSchoolLogo from "../SchoolLogos/DivineSchool.png";

const hasMedia = (school) =>
  (Array.isArray(school?.photos) && school.photos.length > 0) ||
  (Array.isArray(school?.videos) && school.videos.length > 0);

export default function TempSchoolPage() {
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [showAllSchools, setShowAllSchools] = useState(false);
  const [showAllPreschools, setShowAllPreschools] = useState(false);

  const staticWorkshops = [
    {
      id: 1,
      schoolName: "Rahul International School",
      schoolAddress: "Pune",
      logo:RahulInternationalSchoolLogo,
      photos: [risI1, risI2, risI3, risI4, risI5],
      videos: [risV1],
    },
  ];

  const staticPreschools = [
    {
      id: 1,
      schoolName: "C.A.T.S. Preschool",
      schoolAddress: "Pune",
      logo:CATSPreschoolLogo,
      photos: [cpsI1, cpsI2, cpsI3, cpsI4, cpsI5, cpsI6, cpsI7, cpsI8],
      videos: [cpsV1, cpsV2, cpsV3, cpsV4],
    },
    {
      id: 2,
      schoolName: "Shine With Giggles",
      schoolAddress: "Pune",
      logo:ShineWithGigglesLogo,
      photos: [swgI1, swgI2, swgI3],
      videos: [swgV1, swgV2],
    },
     {
      id: 3,
      schoolName: "Pandit Rao Agashe School",
      schoolAddress: "Pune",
      logo:panditraoLogo,
      photos: [PRAO1,PRAO2,PRAO3,PRAO4,PRAO5,PRAO6,PRAO7,PRAO8],
      videos: [PRV1],
    },
    {
      id: 4,
      schoolName: "Leo Kids Preschool",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:LeoKidsPreschoolLogo,
      photos: [lkI1],
      videos: [lkV1, lkV2],
    },
    {
      id: 5,
      schoolName: "The Craayons Play Preschool",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:CraayonsPreschoolLogo,
      photos: [cppsI1, cppsI2, cppsI3, cppsI4],
      videos: [cppsV1, cppsV2],
    },
    {
      id: 6,
      schoolName: "Little Wonder's Nursery Preschool",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:LittleWondersPreschoolLogo,
      photos: [lwnpI1, lwnpI2, lwnpI3, lwnpI4, lwnpI5, lwnpI6, lwnpI7, lwnpI8],
      videos: [lwnpV1],
    },
    {
      id: 7,
      schoolName: "Intelliots Preschool",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:IntelliotsPreschoolLogo,
      photos: [itpI1, itpI2, itpI3, itpI4, itpI5, itpI6, itpI7, itpI8],
      videos: [itpV1, itpV2, itpV3, itpV4, itpV5],
    },
    {
      id: 8,
      schoolName: "Euro Kids Preschool",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:EuroPreschoolLogo,
      photos: [ekpI1, ekpI2, ekpI3, ekpI4, ekpI5, ekpI6, ekpI7, ekpI8],
      videos: [ekpV1, ekpV2, ekpV3, ekpV4],
    },
    {
      id: 9,
      schoolName: "Jumping Jhapak",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:JumpingJhapakLogo,
      photos: [jjI1, jjI2],
      videos: [jjV1, jjV2],
    },
      {
    id: 10,
    schoolName: "The Learning Curve",
    schoolAddress: "Pune",
    logo:LearningCurveLogo,
    photos: [],
    videos: [],
  },
  {
    id: 11,
    schoolName: "Phonics World",
    schoolAddress: "Pune",
    logo:PhonicsLogo,
    photos: [PW1,PW2],
    videos: [PWV1,PWV2,PWV3],
  },
  {
    id: 12,
    schoolName: "CNS Preschool",
    schoolAddress: "Pune",
    logo:CNSLogo,
    photos: [CNS,CNS1,CNS2,CNS3,CNS4,CNS5,CNS6,CNS7,CNS8,CNS9,CNS10,CNS11,CNS12,CNSP1,CNSP2,CNSP3,CNSP4],
    videos: [cnsv2,cnsv3,cnsv4,CNSV5],
  },
  ];

  const staticSchools = [
    {
      id: 1,
      schoolName: "S.S. Agrawal School",
      schoolAddress: "Pune",
      logo:SSAgrawalLogo,
      photos: [ssagI1],
      videos: [ssadV1, ssadV2, ssadV3, ssadV4],
    },
    {
      id: 2,
      schoolName: "Modern Primary School",
      schoolAddress: "Pune",
      logo:modernPrimaryLogo,
      photos: [mpsI1, mpsI2, mpsI3, mpsI4],
      videos: [mpsV1, mpsV2, mpsV3, mpsV4],
    },
    {
      id: 3,
      schoolName: "Pandit Rao Agashe School",
      schoolAddress: "Pune",
      logo:panditraoLogo,
      photos: [prasI1, prasI2, prasI3, prasI4, prasI5],
      videos: [prasV1, prasV2],
    },
    {
      id: 6,
      schoolName: "Modern Secondary School",
      schoolAddress: "Pune",
      logo:modernSecondaryLogo,
      photos: [mssI1, mssI2, mssI3],
      videos: [mssV1, mssV2, mssV3, mssV4, mssV5],
    },

    {
      id: 7,
      schoolName: "Seth Dagdu Katariya School",
      schoolAddress: "Pune",
      logo:SethDagduLogo,
      photos: [sdI1, sdI2],
      videos: [sdV1, sdV2, sdV3],
    },
    {
      id: 8,
      schoolName: "Arjuna Cambridge School",
      schoolAddress: "Chhatrapati Sambhaji Nagar",
      logo:ArjunaLogo,
      photos: [acsI1, acsI2, acsI3, acsI4],
      videos: [acsV1],
    },
  {
    id: 10,
    schoolName: "Arya Mandir School",
    schoolAddress: "Pune",
    logo:AryaMandirLogo,
    photos: [],
    videos: [],
  },
  {
    id: 11,
    schoolName: "Dada Maharaj Natekar School",
    schoolAddress: "Chikali",
    logo:dadamaharajLogo,
    photos: [],
    videos: [],
  },
  {
    id: 12,
    schoolName: "Sai Dreamz School",
    schoolAddress: "Chhatrapati Sambhajinagar",
    logo:SaidreamzLogo,
    photos: [],
    videos: [],
  },
  {
    id: 13,
    schoolName: "Sanskar Dream School",
    schoolAddress: "Chhatrapati Sambhajinagar",
    logo:SanskarLogo,
    photos: [SDI1, SDI2, SDI3, SDI4, SDI5],
    videos: [SDV],
  },
  {
    id: 14,
    schoolName: "P.U. Jain Vidyalaya",
    schoolAddress: "Chhatrapati Sambhajinagar",
    logo:PUJainLogo,
    photos: [PUJ,PUJ2,PUJ3,PUJ4,PUJ5,PUJ6,PUJ7,PUJ8],
    videos: [],
  },
  {
      id: 15,
      schoolName: "Maharashtriya Mandal English Medium School",
      schoolAddress: "Pune",
      logo:maharashtramandalSchoolLogo,
      photos: [MMP,MMP2,MMP3,MMP4,MMP5],
      videos: [MMV,MMV2],
    },
    {
      id: 16,
      schoolName: "Abhishek Vidyalayam",
      schoolAddress: "Pune",
      logo:AbhishekVidyalayamLogo,
      photos: [AVI1,AVI2,AVI3],
      videos: [AVV,AVV2,AVV3],
    },
    {
      id: 17,
      schoolName: "D B NIMBARKAR ENGLISH MED. SCHOOL",
      schoolAddress: "Pune",
      logo:DBNibarkarLogo,
      photos: [],
      videos: [DBN],
    },
    {
      id: 18,
      schoolName: "Divine English Medium School",
      schoolAddress: "Pune",
      logo:DivineSchoolLogo,
      photos: [divineI1, divineI2],
      videos: [divineV1, divineV2],
    },
  ];

  const visibleSchools = staticSchools.filter(hasMedia);
  const visiblePreschools = staticPreschools.filter(hasMedia);
  const visibleWorkshops = staticWorkshops.filter(hasMedia);

 return (
  <main className="ms-network-showcase">
    {!selectedSchool ? (
      <>
        {/* =====================================================
            HERO
        ===================================================== */}

        <section className="ms-network-showcase-hero">
          <div className="ms-network-showcase-grid" />

          <div className="ms-network-showcase-glow ms-network-showcase-glow-blue" />
          <div className="ms-network-showcase-glow ms-network-showcase-glow-yellow" />

          <div className="ms-network-showcase-container">
            <div className="ms-network-showcase-hero-layout">
              {/* LEFT */}

              <div className="ms-network-showcase-hero-copy">
                <div className="ms-network-showcase-kicker">
                  <span />

                  OUR LEARNING NETWORK
                </div>

                <h1>
                  Growing together with
                  <span> schools that believe in learning by doing.</span>
                </h1>

                <p>
                  Explore MindSpark's school, preschool and workshop
                  network and see learning through real projects,
                  activities, photos and experiences.
                </p>

                <div className="ms-network-showcase-brand-note">
                  <div className="ms-network-showcase-brand-mark">
                    <span />
                    <span />
                  </div>

                  <div>
                    <small>
                      MINDSPARK EDUTECH
                    </small>

                    <strong>
                      Learning Through Technology
                    </strong>
                  </div>
                </div>
              </div>

              {/* RIGHT NETWORK SUMMARY */}

              <div className="ms-network-showcase-summary">
                <div className="ms-network-showcase-summary-head">
                  <div>
                    <small>
                      OUR NETWORK
                    </small>

                    <h2>
                      Learning communities
                    </h2>
                  </div>

                  <span className="ms-network-showcase-active">
                    <i />
                    Growing
                  </span>
                </div>

                <div className="ms-network-showcase-summary-grid">
                  <div className="yellow">
                    <strong>
                      {visibleSchools.length}
                    </strong>

                    <span>
                      Schools
                    </span>
                  </div>

                  <div className="purple">
                    <strong>
                      {visiblePreschools.length}
                    </strong>

                    <span>
                      Preschools
                    </span>
                  </div>

                  <div className="blue">
                    <strong>
                      {visibleWorkshops.length}
                    </strong>

                    <span>
                      Workshops
                    </span>
                  </div>
                </div>

                <div className="ms-network-showcase-summary-footer">
                  <span>
                    Schools
                  </span>

                  <i />

                  <span>
                    Preschools
                  </span>

                  <i />

                  <span>
                    Workshops
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            MAIN NETWORK CONTENT
        ===================================================== */}

        <section className="ms-network-showcase-content">
          <div className="ms-network-showcase-container">
            {/* =================================================
                SCHOOLS
            ================================================= */}

            <section className="ms-network-category">
              <div className="ms-network-category-heading">
                <div>
                  <div className="ms-network-showcase-kicker">
                    <span />

                    SCHOOL PARTNERS
                  </div>

                  <h2>
                    Our partner
                    <span> schools.</span>
                  </h2>

                  <p>
                    Schools where students experience practical
                    technology learning through MindSpark.
                  </p>
                </div>

                <div className="ms-network-category-count yellow">
                  <small>
                    TOTAL
                  </small>

                  <strong>
                    {String(visibleSchools.length).padStart(2, "0")}
                  </strong>
                </div>
              </div>

              <div className="ms-network-showcase-grid-cards">
                {(showAllSchools
                  ? visibleSchools
                  : visibleSchools.slice(0, 3)
                ).map((school, index) => (
                  <article
                    key={school.id}
                    className={`ms-network-showcase-card ${
                      ["yellow", "blue", "teal", "purple"][
                        index % 4
                      ]
                    }`}
                    onClick={() => setSelectedSchool(school)}
                  >
                    <div className="ms-network-showcase-card-top">
                      <div className="ms-network-showcase-logo">
                        {school.logo ? (
                          <img
                            src={school.logo}
                            alt={`${school.schoolName} logo`}
                          />
                        ) : (
                          <span className="ms-network-showcase-logo-fallback">
                            {school.schoolName
                              ?.charAt(0)
                              ?.toUpperCase()}
                          </span>
                        )}
                      </div>

                      <span className="ms-network-showcase-card-number">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>

                    <div className="ms-network-showcase-card-content">
                      <span className="ms-network-showcase-card-type">
                        PARTNER SCHOOL
                      </span>

                      <h3>
                        {school.schoolName}
                      </h3>

                      <div className="ms-network-showcase-location">
                        <svg
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path
                            d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                          />

                          <circle
                            cx="12"
                            cy="10"
                            r="2"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                          />
                        </svg>

                        <span>
                          {school.schoolAddress}
                        </span>
                      </div>
                    </div>

                    <div className="ms-network-showcase-media">
                      <div>
                        <strong>
                          {school.photos?.length || 0}
                        </strong>

                        <span>
                          Photos
                        </span>
                      </div>

                      <i />

                      <div>
                        <strong>
                          {school.videos?.length || 0}
                        </strong>

                        <span>
                          Videos
                        </span>
                      </div>
                    </div>

                    <div className="ms-network-showcase-card-footer">
                      <span>
                        Explore school journey
                      </span>

                      <button
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          setSelectedSchool(school);
                        }}
                      >
                        View Details
                        <span>→</span>
                      </button>
                    </div>

                    <div className="ms-network-showcase-card-accent" />
                  </article>
                ))}
              </div>

              {visibleSchools.length > 3 && (
                <div className="ms-network-showcase-more">
                  <button
                    type="button"
                    onClick={() =>
                      setShowAllSchools(!showAllSchools)
                    }
                  >
                    {showAllSchools
                      ? "Show Fewer Schools"
                      : `View All ${visibleSchools.length} Schools`}

                    <span>
                      {showAllSchools ? "↑" : "↓"}
                    </span>
                  </button>
                </div>
              )}
            </section>

            {/* =================================================
                PRESCHOOLS
            ================================================= */}

            <section className="ms-network-category ms-network-preschools">
              <div className="ms-network-category-heading">
                <div>
                  <div className="ms-network-showcase-kicker purple">
                    <span />

                    EARLY LEARNING PARTNERS
                  </div>

                  <h2>
                    Our partner
                    <span className="purple-text"> preschools.</span>
                  </h2>

                  <p>
                    Early learning environments where curiosity,
                    creativity and technology come together.
                  </p>
                </div>

                <div className="ms-network-category-count purple">
                  <small>
                    TOTAL
                  </small>

                  <strong>
                    {String(visiblePreschools.length).padStart(2, "0")}
                  </strong>
                </div>
              </div>

              <div className="ms-network-showcase-grid-cards">
                {(showAllPreschools
                  ? visiblePreschools
                  : visiblePreschools.slice(0, 3)
                ).map((school, index) => (
                  <article
                    key={school.id}
                    className={`ms-network-showcase-card ${
                      ["purple", "yellow", "teal", "blue"][
                        index % 4
                      ]
                    }`}
                    onClick={() => setSelectedSchool(school)}
                  >
                    <div className="ms-network-showcase-card-top">
                      <div className="ms-network-showcase-logo">
                        {school.logo ? (
                          <img
                            src={school.logo}
                            alt={`${school.schoolName} logo`}
                          />
                        ) : (
                          <span className="ms-network-showcase-logo-fallback">
                            {school.schoolName
                              ?.charAt(0)
                              ?.toUpperCase()}
                          </span>
                        )}
                      </div>

                      <span className="ms-network-showcase-card-number">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>

                    <div className="ms-network-showcase-card-content">
                      <span className="ms-network-showcase-card-type">
                        PRESCHOOL PARTNER
                      </span>

                      <h3>
                        {school.schoolName}
                      </h3>

                      <div className="ms-network-showcase-location">
                        <svg
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path
                            d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                          />

                          <circle
                            cx="12"
                            cy="10"
                            r="2"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.7"
                          />
                        </svg>

                        <span>
                          {school.schoolAddress}
                        </span>
                      </div>
                    </div>

                    <div className="ms-network-showcase-media">
                      <div>
                        <strong>
                          {school.photos?.length || 0}
                        </strong>

                        <span>
                          Photos
                        </span>
                      </div>

                      <i />

                      <div>
                        <strong>
                          {school.videos?.length || 0}
                        </strong>

                        <span>
                          Videos
                        </span>
                      </div>
                    </div>

                    <div className="ms-network-showcase-card-footer">
                      <span>
                        Explore preschool journey
                      </span>

                      <button
                        type="button"
                        onClick={(event) => {
                          event.stopPropagation();
                          setSelectedSchool(school);
                        }}
                      >
                        View Details
                        <span>→</span>
                      </button>
                    </div>

                    <div className="ms-network-showcase-card-accent" />
                  </article>
                ))}
              </div>

              {visiblePreschools.length > 3 && (
                <div className="ms-network-showcase-more">
                  <button
                    type="button"
                    onClick={() =>
                      setShowAllPreschools(!showAllPreschools)
                    }
                  >
                    {showAllPreschools
                      ? "Show Fewer Preschools"
                      : `View All ${visiblePreschools.length} Preschools`}

                    <span>
                      {showAllPreschools ? "↑" : "↓"}
                    </span>
                  </button>
                </div>
              )}
            </section>

          {/* =================================================
    WORKSHOPS
================================================= */}

<section className="ms-network-category ms-network-workshops">
  <div className="ms-network-category-heading">
    <div>
      <div className="ms-network-showcase-kicker blue">
        <span />

        WORKSHOP EXPERIENCES
      </div>

      <h2>
        Learning through
        <span> workshops.</span>
      </h2>

      <p>
        Hands-on sessions where students
        experiment, create and learn through
        practical activities.
      </p>
    </div>

    <div className="ms-network-category-count blue">
      <small>
        TOTAL
      </small>

      <strong>
        {String(
          visibleWorkshops.length
        ).padStart(2, "0")}
      </strong>
    </div>
  </div>

  {/* FEATURED WORKSHOP LAYOUT */}

  <div className="ms-workshop-feature-list">
    {visibleWorkshops.map(
      (school, index) => (
        <article
          key={school.id}
          className="ms-workshop-feature-card"
          onClick={() =>
            setSelectedSchool(school)
          }
        >
          {/* NUMBER */}

          <span className="ms-workshop-feature-number">
            {String(
              index + 1
            ).padStart(2, "0")}
          </span>

          {/* LOGO */}

          <div className="ms-workshop-feature-logo">
            <img
              src={school.logo}
              alt={`${school.schoolName} logo`}
            />
          </div>

          {/* CONTENT */}

          <div className="ms-workshop-feature-content">
            <div className="ms-workshop-feature-label">
              <span />

              WORKSHOP EXPERIENCE
            </div>

            <h3>
              {school.schoolName}
            </h3>

            <div className="ms-workshop-feature-location">
              <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <circle
                  cx="12"
                  cy="10"
                  r="2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />
              </svg>

              {school.schoolAddress}
            </div>

            <p>
              Explore real moments from
              hands-on technology activities,
              student participation and
              practical learning experiences.
            </p>
          </div>

          {/* MEDIA */}

          <div className="ms-workshop-feature-media">
            <div>
              <small>
                PHOTOS
              </small>

              <strong>
                {String(
                  school.photos?.length ||
                    0
                ).padStart(2, "0")}
              </strong>
            </div>

            <span />

            <div>
              <small>
                VIDEOS
              </small>

              <strong>
                {String(
                  school.videos?.length ||
                    0
                ).padStart(2, "0")}
              </strong>
            </div>
          </div>

          {/* ACTION */}

          <button
            type="button"
            className="ms-workshop-feature-button"
            onClick={(event) => {
              event.stopPropagation();

              setSelectedSchool(
                school
              );
            }}
          >
            Explore Workshop

            <span>→</span>
          </button>

          <div className="ms-workshop-feature-accent" />
        </article>
      )
    )}
  </div>
</section>
          </div>
        </section>
      </>
    ) : (
      /* =====================================================
          SCHOOL DETAILS
      ===================================================== */

      <section className="ms-network-details-wrapper">
        <div className="ms-network-showcase-container">
          <SchoolDetails
            school={selectedSchool}
            onBack={() => setSelectedSchool(null)}
          />
        </div>
      </section>
    )}
  </main>
);
}
